import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import {
  Datastore,
  DatastoreDocument,
  RequestStatus,
} from '@freelancer/datastore';
import {
  SimilarShowcasesCollection,
  SimilarTag,
} from '@freelancer/datastore/collections';
import { ButtonColor, ButtonSize } from '@freelancer/ui/button';
import { CardSize } from '@freelancer/ui/card';
import { Margin } from '@freelancer/ui/margin';
import { PictureDisplay } from '@freelancer/ui/picture';
import { FontWeight, TextAlign, TextSize } from '@freelancer/ui/text';
import * as Rx from 'rxjs';

@Component({
  selector: 'app-user-profile-browse-showcases',
  template: `
    <ng-container
      *ngIf="
        !(similarShowcasesStatus$ | flAsync)?.ready &&
        !(similarShowcasesStatus$ | flAsync)?.error
      "
    >
      <fl-card [size]="CardSize.SMALL">
        <fl-card-header-title>
          <fl-loading-text [rows]="1" [padded]="false"></fl-loading-text>
        </fl-card-header-title>
        <fl-loading-text [rows]="4" [padded]="false"></fl-loading-text>
      </fl-card>
    </ng-container>

    <ng-container
      *ngIf="
        (similarShowcasesStatus$ | flAsync)?.ready &&
        (similarShowcasesDocument.valueChanges() | flAsync) as similarShowcases
      "
    >
      <fl-card *ngIf="similarShowcases.tags.length > 0" [size]="CardSize.SMALL">
        <fl-card-header-title i18n="Browse similar showcases header title">
          Browse Similar Showcases
        </fl-card-header-title>

        <fl-bit class="SimilarFreelancers">
          <fl-button
            flTrackingLabel="BrowseShowcaseClick"
            *ngFor="
              let similarShowcase of similarShowcases.tags;
              trackBy: trackBySimilarTag
            "
            [color]="ButtonColor.TRANSPARENT_DARK"
            [flMarginRight]="Margin.XXSMALL"
            [flMarginBottom]="Margin.XXSMALL"
            [size]="ButtonSize.MINI"
            [link]="similarShowcase.url"
          >
            <fl-text [size]="TextSize.XXSMALL" [weight]="FontWeight.NORMAL">
              {{ similarShowcase.label }}
            </fl-text>
          </fl-button>
        </fl-bit>
      </fl-card>
    </ng-container>
  `,
  styleUrls: ['./user-profile-browse-showcases.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProfileBrowseShowcasesComponent implements OnInit {
  ButtonColor = ButtonColor;
  ButtonSize = ButtonSize;
  CardSize = CardSize;
  TextSize = TextSize;
  FontWeight = FontWeight;
  Margin = Margin;
  PictureDisplay = PictureDisplay;
  TextAlign = TextAlign;

  @Input() userProfileId$: Rx.Observable<number>;

  similarShowcasesDocument: DatastoreDocument<SimilarShowcasesCollection>;
  similarShowcasesStatus$: Rx.Observable<
    RequestStatus<SimilarShowcasesCollection>
  >;

  constructor(private datastore: Datastore) {}

  ngOnInit(): void {
    this.similarShowcasesDocument = this.datastore.document<SimilarShowcasesCollection>(
      'similarShowcases',
      this.userProfileId$,
    );

    this.similarShowcasesStatus$ = this.similarShowcasesDocument.status$;
  }

  trackBySimilarTag(index: number, similarTag: SimilarTag): string {
    return similarTag.label;
  }
}
